import React from 'react';
import { motion } from 'framer-motion';

const Hero: React.FC = () => {
  return (
    <section className="bg-black min-h-screen relative overflow-hidden">
      {/* Mobile Layout */}
      <div className="lg:hidden flex flex-col h-screen">
        {/* Text Section - Top Half */}
        <div className="flex-1 flex flex-col justify-center items-center px-6 pt-20 pb-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-center leading-tight mb-8">
            <span className="text-white">Building</span>
            <br />
            <span className="text-[#3783FE]">Next-gen</span>{' '}
            <span className="text-[#F22D5E]">AI</span>
            <br />
            <span className="text-white">Mobile & Web</span>
            <br />
            <span className="text-white">Applications</span>
          </h1>
        </div>

        {/* Mobile Hero Image - Bottom Half, Partially Visible */}
        <div className="flex-1 flex items-end justify-center pb-8">
          <div className="relative">
            {/* Radial gradient glow effect */}
            <div className="absolute inset-0 bg-gradient-radial from-[#F22D5E]/40 via-[#F22D5E]/20 to-transparent rounded-full blur-3xl scale-150"></div>
            <img 
              src="/assets/hero.png" 
              alt="Koral mobile app interface" 
              className="relative z-10 w-40 h-auto"
            />
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:flex items-center pt-24 pb-8 px-4 sm:px-6 h-screen">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Left side - Text content */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-left lg:pl-8"
            >
              <motion.h1 
                className="text-7xl xl:text-8xl font-bold mb-6 sm:mb-8 lg:mb-12 leading-tight"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                <span className="text-white">Building</span>
                <br />
                <span className="text-[#3783FE]">Next-gen</span>{' '}
                <span className="text-[#F22D5E]">AI</span>
                <br />
                <span className="text-white">Mobile & Web</span>
                <br />
                <span className="text-white">Applications</span>
              </motion.h1>
            </motion.div>

            {/* Right side - Hero phone image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="flex justify-center"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                className="relative"
              >
                {/* Enhanced radial gradient glow effect */}
                <div className="absolute inset-0 bg-gradient-radial from-[#F22D5E]/40 via-[#F22D5E]/20 to-transparent rounded-full blur-3xl scale-150"></div>
                <img 
                  src="/assets/hero.png" 
                  alt="Koral mobile app interface" 
                  className="relative z-10 w-[15.4rem] xl:w-[17.6rem] h-auto"
                />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
